// Ассистент «Спросить CRM» — обёртка над `/assistant`.
// Контракт сверен с apps/api/src/modules/assistant/assistant.controller.ts.
//
// Сотрудник в запросах НЕ передаётся: сервер берёт его из сессии, диалоги
// личные. Передавать id отсюда было бы дырой, а не удобством.

import { api } from '@/lib/api';

export interface AssistantStatus {
  enabled: boolean;
  model: 'haiku' | 'sonnet' | null;
}

export interface AssistantThread {
  id: string;
  title: string | null;
  last_message_at: string | null;
  created_at: string;
}

export interface AssistantEntity {
  kind: string;
  label: string;
  href: string;
}

export interface AssistantMessage {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  error: string | null;
  created_at: string;
  entities?: Record<string, AssistantEntity>;
}

export function getAssistantStatus(): Promise<AssistantStatus> {
  return api.get<AssistantStatus>('/assistant/status');
}

export function listAssistantThreads(): Promise<AssistantThread[]> {
  return api.get<{ threads: AssistantThread[] }>('/assistant/threads').then((r) => r.threads);
}

export function createAssistantThread(): Promise<AssistantThread> {
  return api.post<AssistantThread>('/assistant/threads');
}

export function listAssistantMessages(threadId: string): Promise<AssistantMessage[]> {
  return api
    .get<{ messages: AssistantMessage[] }>(`/assistant/threads/${threadId}/messages`)
    .then((r) => r.messages);
}

/**
 * Задать вопрос.
 *
 * `idempotencyKey` приходит СНАРУЖИ и живёт, пока текст вопроса не изменился:
 * повтор после обрыва обязан вернуть уже оплаченный ответ, а не купить второй.
 * Меняете текст — меняйте ключ, иначе получите старый ответ на новый вопрос.
 */
export function askAssistant(
  threadId: string,
  input: { text: string; screen?: string; idempotencyKey: string },
): Promise<{ question: AssistantMessage; answer: AssistantMessage }> {
  return api.post<{ question: AssistantMessage; answer: AssistantMessage }>(
    `/assistant/threads/${threadId}/messages`,
    {
      text: input.text,
      ...(input.screen ? { screen: input.screen } : {}),
      idempotency_key: input.idempotencyKey,
    },
    { idempotencyKey: input.idempotencyKey },
  );
}
